import productImage from '../assets/product/rt10-vial-hero-placeholder-v1.png';

export const product = {
  sku: 'RT-10',
  lot: 'RT10-2406A',
  title: 'RT-10 Research Compound',
  shortDescription: '10 mg sealed research vial. For laboratory research use only.',
  image: productImage,
  specs: [
    ['SKU', 'RT-10'],
    ['Format', 'Sealed vial'],
    ['Fill size', '10 mg'],
    ['Lot ID', 'RT10-2406A'],
    ['COA status', 'Available'],
    ['SDS status', 'Pending'],
    ['Sellable unit', '1 vial']
  ],
  documents: [
    ['Certificate of Analysis - RT10-2406A', 'COA', 'PDF - third-party', 'Available'],
    ['Lot trace card - RT10-2406A', 'TRACE', 'PDF', 'Available'],
    ['Handling and storage card', 'CARE', 'PDF', 'Available'],
    ['Safety data sheet', 'SDS', 'Test pending', 'Pending'],
    ['Research-use policy insert', 'RUO', 'PDF', 'Available']
  ],
  proof: [
    'Lot documentation',
    'Third-party COA',
    'Tracked global fulfillment',
    'Research-use checkout'
  ],
  verification: [
    'Lot and SKU match the COA on the documentation sheet.',
    'Seal and label are checked before dispatch.',
    'Dispatch in 1-3 business days after approval.',
    'Tracking milestones visible from fulfillment center to destination.',
    'Support review if tracking stalls past the published threshold.'
  ],
  faqs: [
    [
      'What is included?',
      'One sealed 10 mg research vial per unit, plus the documentation kit: COA summary, lot trace, handling card, and research-use insert.'
    ],
    [
      'How long does tracking take?',
      'Handling is 1-3 business days. Most Tier-1 delivery is 9-11 business days after dispatch. Country windows can vary by customs review.'
    ],
    [
      'What documents are available?',
      'Lot-specific COA, lot trace card, handling notes, and research-use policy insert. SDS is shown as pending until finalized.'
    ],
    [
      'Is this for human or veterinary use?',
      'No. For laboratory research use only. Not for human or veterinary use.'
    ],
    [
      'Do you provide protocol or human-use guidance?',
      'No. Aminoscale does not provide medical advice or human-use instructions of any kind.'
    ]
  ]
};

export const trustPillars = [
  {
    title: 'Lot documentation',
    body: 'Every vial carries a lot ID that matches its COA, label, and checkout record.'
  },
  {
    title: 'Third-party COA',
    body: 'Lot-specific independent testing is posted to the documentation vault.'
  },
  {
    title: 'Tracked fulfillment',
    body: 'Published country windows, tracked delivery, and a support review threshold.'
  },
  {
    title: 'Compliance-first checkout',
    body: 'Research-use attestations are captured before payment moves forward.'
  }
];

export const processSteps = [
  ['Supplier batch', 'Inbound lot received and logged against declared identity.'],
  ['Independent test', 'Lot-specific test result captured for the COA record.'],
  ['Fulfillment receiving', 'Seal, label, and lot references checked before dispatch.'],
  ['Documentation kit', 'COA summary, lot trace, handling, and RUO insert prepared.'],
  ['Tracked delivery', 'Route and delivery window shown before checkout completion.'],
  ['Support review', 'Stalled tracking is reviewed against the published threshold.']
];
